export default __webpack_public_path__ + "static/flutter-app-development-company-peerbits-f037d739902eed8c07038c2140381cb1.png";